import styles from './DateTimeSpan.module.scss';

export interface DateTimeSpanProps {
  startDateTime: string;
  endDateTime: string;
  status: string;
}

function DateTimeSpan({
  startDateTime,
  endDateTime,
  status,
}: DateTimeSpanProps): JSX.Element {
  const DAY_MILLISECONDS = 1000 * 60 * 60 * 24;

  const dateTimeSpan = [new Date(startDateTime), new Date(endDateTime)];
  const diffStartToEndDate = Number(dateTimeSpan[1]) - Number(dateTimeSpan[0]);
  const diffDays = Math.ceil(diffStartToEndDate / DAY_MILLISECONDS);

  function getMonthName(dateTime: Date) {
    const monthNames = [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ];

    return monthNames[dateTime.getMonth()];
  }

  function getDate(dateTime: Date) {
    if (status === 'in_progress' || status === 'opened') {
      if (diffDays >= 7) {
        return getMonthName(dateTime);
      }

      return dateTime.toLocaleString('pt-BR', {
        weekday: 'short',
      });
    }

    if (status === 'scheduled') {
      const diffCurrentToStartDate = Math.ceil(
        (Number(dateTimeSpan[0]) - new Date().getTime()) / DAY_MILLISECONDS,
      );

      if (diffCurrentToStartDate >= 7) {
        return getMonthName(dateTime);
      }

      return dateTime.toLocaleString('pt-BR', {
        weekday: 'short',
      });
    }

    return getMonthName(dateTime);
  }

  return (
    <div className={styles.wrapper} data-testid="date-time">
      {dateTimeSpan.map((dateTime, index) => {
        const ariaLabelPrefix = index === 0 ? 'Inicia' : 'Termina';
        const ariaLabelDate = dateTime.toLocaleString('pt-BR', {
          dateStyle: 'full',
          timeStyle: 'short',
        });

        return (
          <time key={ariaLabelPrefix + ariaLabelDate} className={styles.date}>
            <abbr className="sr-only">{`${ariaLabelPrefix} em ${ariaLabelDate}`}</abbr>

            <span className={styles.weekday} aria-hidden>
              {getDate(dateTime)}
            </span>

            <span className={styles.day} aria-hidden>
              {dateTime.toLocaleString('pt-BR', {day: '2-digit'})}
            </span>

            <span className={styles.time} aria-hidden>
              {dateTime.toLocaleString('pt-BR', {timeStyle: 'short'})}
            </span>
          </time>
        );
      })}
    </div>
  );
}

export default DateTimeSpan;
